import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { types } from 'mobx-state-tree';
import { api } from 'src/api';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { createAsync } from 'src/utils/asyncModel';
const getCurrentCompanyId = () => {
  const companyId = localStorage.getItem(USER_SETTINGS_KEYS.company);

  // localStorage holds the STRING 'null' (or 'undefined') when no company is selected, so a
  // truthiness check alone would aim every request at /companies/null/… — same guard as the
  // intake banner uses.
  return !companyId || companyId === 'null' || companyId === 'undefined' ? '' : companyId;
};

/**
 * The company's allowed senders — who may email bills in (LB-5781, over the LB-5764 API).
 *
 * No cached list here on purpose: the list is read inside one modal, always fresh on open, and a
 * copy in the store would be one more thing to keep honest. The actions exist for the async
 * plumbing (cancellation, the error toast with the server's message — the 409 duplicate text is
 * the useful one) rather than for shared state.
 */
const getAllowedSendersAsync = createAsync(() => {
  return async function getAllowedSenders(options) {
    const companyId = getCurrentCompanyId();
    if (!companyId) return undefined;
    return api.BillAutomationAllowedSenders.getAllowedSenders({
      companyId
    }, options);
  };
});
const addAllowedSenderAsync = createAsync(body => {
  return async function addAllowedSender(options) {
    const companyId = getCurrentCompanyId();
    if (!companyId) return undefined;
    return api.BillAutomationAllowedSenders.addAllowedSender(_objectSpread({
      companyId
    }, body), options);
  };
});
const updateAllowedSenderAsync = createAsync(body => {
  return async function updateAllowedSender(options) {
    const companyId = getCurrentCompanyId();
    if (!companyId) return undefined;
    return api.BillAutomationAllowedSenders.updateAllowedSender(_objectSpread({
      companyId
    }, body), options);
  };
});
const deleteAllowedSenderAsync = createAsync(body => {
  return async function deleteAllowedSender(options) {
    const companyId = getCurrentCompanyId();
    if (!companyId) return undefined;
    return api.BillAutomationAllowedSenders.deleteAllowedSender(_objectSpread({
      companyId
    }, body), options);
  };
});
const AllowedSendersStore = types.model('AllowedSendersStore', {
  getAllowedSendersAsync,
  addAllowedSenderAsync,
  updateAllowedSenderAsync,
  deleteAllowedSenderAsync
});
export const allowedSenders = types.optional(AllowedSendersStore, {});